import Shape from "ui/atoms/Shape/Shape";
import DifficultSelector from "ui/molecules/DifficultySelector/DifficultySelector";
import { GameRound } from "shared/games/types/GameRound";
import { Difficulty } from "shared/games/Difficulty";
import {
  AllTechniqueGameDescriptions,
  PointsByDifficulty,
} from "shared/games/allTechniqueGameDescriptions";

interface Props {
  techniquesAndGames: AllTechniqueGameDescriptions;
  onDifficultyChange: (difficulty: Difficulty) => void;
  value: GameRound;
  onLoadableClick: () => Promise<string>;
}

const defaultPoints: PointsByDifficulty = {
  easy: 0,
  medium: 0,
  hard: 0,
};

export default function DifficultySelectorAndStart({
  onDifficultyChange,
  value,
  techniquesAndGames,
  onLoadableClick,
}: Props) {
  const selectedGames = Object.values(techniquesAndGames)
    .filter(({ technique }) => value.techniques.includes(technique))
    .flatMap((technique) =>
      Object.values(technique.games).filter((game) =>
        value.games.includes(game.game)
      )
    );

  // use the first games point's since all games should have the same points
  const points =
    selectedGames.find((game) => game.points)?.points ?? defaultPoints;
  const pointsWhenCompleted =
    selectedGames.find((game) => game.pointsWhenCompleted)?.points ??
    defaultPoints;

  return (
    <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr,100px] lg:gap-4">
      <div className="flex items-center">
        <DifficultSelector
          games={selectedGames}
          points={points}
          pointsWhenCompleted={pointsWhenCompleted}
          onChange={onDifficultyChange}
          value={value.difficulty}
        />
      </div>

      <div className="col-span-1 flex items-center justify-center">
        <Shape
          disabled={selectedGames.length === 0}
          onLoadableClick={onLoadableClick}
          type="content"
          theme="green"
          shape="circle"
          sizeClassName="max-w-[150px] w-full"
        >
          <div className="font-brik text-4xl lg:text-xl">Go!</div>
        </Shape>
      </div>
    </div>
  );
}
